import styled from "styled-components";

export const ContactSlideOutContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  max-height: calc(100vh - 292px);
`;


export const LeftSlotWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 16px;
`;

export const ContactWidgetContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const ContactTopContent = styled.div`
    display: flex;
    flex-direction: row;
    gap: 24px;
`;
export const ContactTopLeftContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const ContactBottomContent = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
`;
export const ContactBottomLeftContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
export const ContactBottomLeftItem = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
`;
export const ContactBottomRightContent = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
`;